import Companylogo from "../Sitelogo.png";
import Sitelogo from "../CSDLogo.svg";

const GlobalData = {
  company: {
    companyName: "Jetty Estates Heart Foundation",
    companyPhone: "+91 9885969292",
    companyEmail: "mail@jettyestates.com",
    companyAddress: "Visakhapatnam, Andhra Pradesh",
    companyWhatsapp: "https://api.whatsapp.com/send?phone=919885969292",

    /*Social media */
    companyfacebook: "https://www.facebook.com/jettyestates",
    companyinstagram: "https://www.instagram.com/jetty_estates/",
    companygit: "https://github.com/jettyestates",
    companytwitter: "https://twitter.com/jettyestates",
    companyyoutube: "https://youtube.com/jettyestates",
    companylinkedin: "https://linkedin.com/company/jettyestates",
  },

  developerdetails: {
    developerName: "Cyber Space Digital",
    developerCompany: "Cyber Space Digital",
    developerPhone: "+91 81434 07758",
    developerEmail: "mail@cyberspacedigital.in",
    developerAddress: "Visakhapatnam, Andhra Pradesh 530017",
    developerWhatsapp: "https://api.whatsapp.com/send?phone=918143407758",
  },
};

export { GlobalData, Companylogo, Sitelogo };
